import React from 'react';
import { Link } from 'react-router-dom';

const Blockchain = () => {
    return (
        <div>
            <div>
  <div className="breadcrumb-banner-area" style={{backgroundImage: 'url(./img/service-header.png)'}}>
    <div className="container">
      <div className="row mb-5">
        <div className="col-md-12">
          <div className="breadcrumb-text text-center">
            <p>Our Services</p>
            <h2>Blockchain development</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br />
  <br />
  {/* breadcrumb-banner-area-end */}
  <div className="container">
    <div className="row mb-5">
      <div className="col-sm-12 col-lg-7 align-self-center">
        <div>
          <p>Our Blockchain application is a complete package, customized according to your needs.  Techarabiya aiming to bring a new change in the Blockchain technology. We aim to build a decentralized system, using smart tokens, Blockchain ledgers and smart contracts.</p>
          <p>Our Blockchain application is a complete package, customized according to your needs.  Techarabiya aiming to bring a new change in the Blockchain technology. We aim to build a decentralized system, using smart tokens, Blockchain ledgers and smart contracts.
          </p>
          <p>With efficient Blockchain solutions, a business develops a smooth workflow and 
            initiates cost saving. We are capable to develop a strong and efficient Blockchain 
            network from personal to ICO.</p>
        </div>
      </div>
      <div className="col-sm-12 col-lg-5">
        <img src="./img/blockhain1.png" className="img-fluid img-blockchain" />
      </div>
    </div>
  </div>
  <div className="container">
    <div className="text-center">
      <div className="col-12 hr-style">
        <br />
        <h2><b>Services We Offer</b></h2>
        <hr />
        <br />
      </div>
    </div>
  </div>
  {/*==========================
Services Section
    ============================*/}
  <section id="blockchain">
    <div className="container">
      <div className="row mb-5">
        <div className="col-lg-6">
          <div className="box wow fadeInLeft">
            <div className="icon"><img className="icon" src="./img/blockchain2.png" /></div>
            <h4 className="title">Blockchain Advisory</h4>
            <p className="description">With years of experience in specific businesses, we have learned to use 
              knowledge in our client’s favor. We can help you identify the right Blockchain to accomplish your needs. Our experts analyze potential Blockchain platforms, appropriate tools to use, evaluates the market conditions, and strategize 
              everything for you.</p>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="box wow fadeInRight">
            <div className="icon"><img className="icon" src="./img/b-1.png" /></div>
            <h4 className="title">Ethereum DApps Development</h4>
            <p className="description">We build decentralized applications (DApps) and develop smart contracts. We specializes in Blockchain-based application from scratch or adapt your existing systems to use Blockchain and smart contracts and covers areas such as decentralized investing platforms, video streaming platforms, 
              decentralized trading solutions, escrows and more.</p>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="box wow fadeInLeft">
            <div className="icon"><img className="icon" src="./img/blockchain3.png" /></div>
            <h4 className="title">Core Blockchain Development</h4>
            <p className="description">We specialize in custom Blockchain development. Our solutions are based on forks of popular Blockchain such as Bitcoin, Ethereum, Dash, ZCash and Decred. Our experience covers solutions such as fully decentralized exchanges and 
              decentralized mining platforms.</p>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="box wow fadeInRight">
            <div className="icon"><img className="icon" src="./img/blockchain4.png" /></div>
            <h4 className="title">Blockchain-Based systems</h4>
            <p className="description">We build custom Blockchain-based systems that support various industries such as Fintech, Trading, Investment, Energy Management, Retail etc. Our 
              experience covers platforms such as Cryptocurrency Exchanges, P2P trading platforms, Web Wallets, Warm/Cold wallets and more.</p>
          </div>
        </div>
      </div>
    </div>
  </section>{/* #services */}
  {/*- Contact Us bar */}
  <div className="container contactus">
  <div className="row mb-5">
    <div className="col-lg-8 col-sm-12 align-self-center">
		<div className="d-flex justify-content-center">
		<span className="contact-text">Are you ready to work with us? Get in touch now!</span>
		</div>    
     
    </div>
    <div className="col-lg-4 col-sm-12 align-self-center">
      <div className="d-flex justify-content-center">
		 <Link to="/ContactUs" className="contact-button"> CONTACT US NOW </Link>
      </div>
    </div>
  </div>
</div>
</div>

        </div>
    )
}

export default Blockchain
